module.exports = __webpack_public_path__ + "img/banner1.f98d3538.png";